import cx from "classnames";
import { type FC, type PropsWithChildren } from "react";

import { ExpandedSection } from "@moment/design-system";

import { PropertiesPaneSectionContainer } from "./PropertiesPaneSectionContainer";

export const PropertiesSection: FC<
	PropsWithChildren<{
		title: string;
		noPadding?: boolean;
		noBorder?: boolean;
		noChildSpacing?: boolean;
		collapseByDefault: boolean;
	}>
> = ({ children, title, noPadding, noBorder, noChildSpacing, collapseByDefault }) => {
	return (
		<PropertiesPaneSectionContainer withBorder={!noBorder} noPadding>
			<ExpandedSection
				headerClassName="px-4 py-2 [&[data-expanded=true]]:py-4"
				label={<div className={`text-primary py-1 font-semibold text-sm`}>{title}</div>}
				collapsedByDefault={collapseByDefault}
			>
				<div
					className={cx(
						"flex flex-col pb-4",
						{ "space-y-2": !noChildSpacing },
						{ "px-4": !noPadding }
					)}
				>
					{children}
				</div>
			</ExpandedSection>
		</PropertiesPaneSectionContainer>
	);
};
